import { createRestSlice } from "./restSlice";

export type TwilioCredentials = {
  accountSid: string;
  apiKeySid: string;
  apiKeySecret: string;
  region?: string;
};

export type TelnyxCredentials = {
  apiKey: string;
};

export type SbcCredentials = {
  baseUrl: string;
  dashboardUrl: string;
  gateway: string;
  twilioAccountSid: string;
  twilioAuthToken: string;
  twilioTrunkName: string;
  dashboardUser: string;
  dashboardPassword: string;
};

export type InfobipCredentials = {
  apiKey: string;
  baseUrl: string;
  mediaStreamConfigId: string;
};

export type TelephonyCredentials = TwilioCredentials | TelnyxCredentials | SbcCredentials | InfobipCredentials;

export type OrganizationTelephony = {
  id: string;
  organizationId: string;
  name: string;
  providerType: string;
  credentials: TelephonyCredentials;
  publicCredentials?: Record<string, string>;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const organizationTelephonySlice = createRestSlice<OrganizationTelephony>("organizationTelephony", "/v1/organization-telephony");

export const organizationTelephonyReducer = organizationTelephonySlice.reducer;
export const organizationTelephonyActions = organizationTelephonySlice.actions;
